import { preferredLanguageAtom } from '@openeducation/hr-rn-jotai-atoms';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { useAtomValue } from 'jotai';
import React, { memo, useMemo } from 'react';
import { Bar } from 'react-chartjs-2';

import { generateMonthLabels } from '../../helpers/generate-month-labels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface ActivitiesBarChartProps {
  data: number[];
  barsColor: string;
  scalesHeight: number;
}

const ActivitiesBarChart = ({
  data,
  barsColor,
  scalesHeight,
}: ActivitiesBarChartProps) => {
  const language = useAtomValue(preferredLanguageAtom);
  const labels = generateMonthLabels(language);
  const isEmpty = data.every((value: number) => value === 0);

  const options = useMemo(
    () => ({
      responsive: true,
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        tooltip: {
          displayColors: false,
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
        },
        y: {
          min: 0,
          suggestedMax: isEmpty ? 10 : undefined,
        },
      },
    }),
    [isEmpty]
  );

  const dataset = useMemo(
    () => ({
      labels,
      datasets: [
        {
          label: '',
          data,
          backgroundColor: barsColor,
          borderRadius: 4,
        },
      ],
    }),
    [labels, data, barsColor]
  );

  return <Bar options={options} data={dataset} height={scalesHeight} />;
};

export default memo(ActivitiesBarChart);
